import api from '../collums-components/api/config';

class MembershipCategoriesApi {
    static getCategories(query) {
        return api.request({
            method: 'GET',
            url: `/membership/categories${query}`
        });
    }

    static getCategory(categoryId) {
        return api.request({
            method: 'GET',
            url: `/membership/categories/${categoryId}`
        });
    }

    static filter(value = '', isSub = false, isFromOrg = false) {
        return api.request({
            method: 'GET',
            url: `/membership/categories/filterBy?name=${value}&isSub=${isSub}&isFromOrg=${isFromOrg}`
        });
    }

    static createCategory(data) {
        return api.request({
            method: 'POST',
            url: '/membership/categories',
            data: data
        });
    }

    static updateCategory(categoryId, data, clinic, isFromOrg = false) {
        return api.request({
            method: 'PUT',
            url: `/membership/categories/${categoryId}?clinic=${clinic}&isFromOrg=${isFromOrg}`,
            data: data
        });
    }

    static deleteCategory(categoryId) {
        return api.request({
            method: 'DELETE',
            url: `/membership/categories/${categoryId}`
        });
    }

    static archiveCategory(categoryId, value, clinic, isFromOrg = false) {
        return api.request({
            method: 'POST',
            url: `/membership/categories/${categoryId}/archive?value=${value}&clinic=${clinic}&isFromOrg=${isFromOrg}`
        });
    }

    static changeActiveCategory(categoryId, value, clinic, isFromOrg = false) {
        return api.request({
            method: 'PUT',
            url: `/membership/categories/${categoryId}/change-active?value=${value}&clinic=${clinic}&isFromOrg=${isFromOrg}`
        });
    }

    static changeCategoryShowOnline(categoryId) {
        return api.request({
            method: 'PUT',
            url: `/membership/categories/${categoryId}/change-show-online`
        });
    }
}

export default MembershipCategoriesApi;
